<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Sales Log</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="#">Home</a></li>
              <li class="breadcrumb-item active">Sales Log</li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <a
              href="javascript:void(0)"
              class="btn btn-info"
              @click="showFilter = !showFilter"
              ><i class="fa fa-filter"></i>Filter</a
            >

            <div class="card-tools">
              <router-link
                v-if="actionCreate == true"
                :to="{ name: 'SalesLogAdd' }"
                class="btn btn-success"
              >
                <i class="fas fa-plus"></i> New
              </router-link>
            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <div class="card-body p-0">
            <form @submit.prevent="getList()" method="GET" novalidate>
              <div class="card-body" v-if="showFilter">
                <div class="row"></div>
                <div class="row">
                  <div class="col-10 offset-1">
                    <button type="submit" class="btn btn-primary m-2px">
                      Search
                    </button>
                    <button
                      type="reset"
                      class="btn btn-warning"
                      @click="resetFilter()"
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Client Reference-Id</th>
                    <th>Account ID</th>
                    <th>amount</th>
                    <th>Commission amount</th>
                    <th>Accounting Trx Ref-Id</th>
                    <th>Accounting Trx Response Code</th>
                    <th>Status</th>
                    <th>Product-Id</th>
                    <th>Product Quantity</th>
                    <th>User-Id</th>
                    <th>Customer-Id</th>
                    <th>User Role-Id</th>
                    <th>Customer Role-Id</th>
                    <th>User Organization-Id</th>
                    <th>Customer Organization-Id</th>
                    <th>App ID</th>
                    <th class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody class="list">
                  <tr v-for="(val, index) in list.data">
                    <td>{{ val.id }}</td>
                    <td>{{ val.client_ref_id }}</td>
                    <td>{{ val.account_id }}</td>
                    <td>{{ val.amount }}</td>
                    <td>{{ val.commission_amount }}</td>
                    <td>{{ val.acct_trx_ref_id }}</td>
                    <td>{{ val.acct_trx_resp_code }}</td>
                    <td>{{ val.status }}</td>
                    <td>{{ val.product_id }}</td>
                    <td>{{ val.product_quantity }}</td>
                    <td>{{ val.user_id }}</td>
                    <td>{{ val.customer_id }}</td>
                    <td>{{ val.user_role_id }}</td>
                    <td>{{ val.customer_role_id }}</td>
                    <td>{{ val.user_org_id }}</td>
                    <td>{{ val.customer_org_id }}</td>
                    <td>{{ val.app_id }}</td>
                    <td class="text-right">
                      <router-link
                        v-if="actionView == true"
                        :to="{ name: 'SalesLogShow', params: { id: val.id } }"
                        class="btn btn-info btn-sm m-2px"
                      >
                        <i class="fas fa-eye"></i>
                      </router-link>
                      <router-link
                        v-if="actionEdit == true"
                        :to="{ name: 'SalesLogEdit', params: { id: val.id } }"
                        class="btn btn-info btn-sm m-2px"
                      >
                        <i class="fas fa-pencil-alt"></i>
                      </router-link>
                      <a
                        v-if="actionDelete == true"
                        class="btn btn-danger btn-sm m-2px"
                        href="javascript:void(0)"
                        @click="deleteObject(val.id, index)"
                        ><i class="fas fa-trash"></i
                      ></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="getList()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import { CBSCommissionApi } from "@/services/api";

export default {
  name: "SalesLog",
  components: {
    VuePagination,
  },
  data: () => ({
    list: {
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    },
    actionCreate: false,
    actionView: true,
    actionEdit: false,
    actionDelete: false,
    showFilter: false,
    filter: {},
    pre: [],
    is_loading: false,
    empty: false,
    empty_message: "",
  }),
  mounted: function () {
    this.getList();
  },
  methods: {
    getList: function () {
      this.is_loading = true;
      CBSCommissionApi.getSalesLog(
        this.list.current_page,
        this.filter,
        this.list.per_page
      )
        .then((items) => {
          this.list = items;
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    resetFilter() {
      this.list.current_page = 1;
      this.filter = {};
      this.getList();
    },
  },
};
</script>
